import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../../../_services/spinner.service';
import { CustomValidators } from '../../../../_shared/custom-validator';
import { OfflineUtilsService } from '../../../services/offline-utils.service';
import { CommonSnackBarService } from '../../../../_services/common-snack-bar.service';

@Component({
    selector: 'app-select-local-folder-path-dialog',
    templateUrl: './select-local-folder-path-dialog.component.html',
    styleUrls: ['./select-local-folder-path-dialog.component.scss'],
    standalone: false
})
export class SelectLocalFolderPathDialogComponent implements OnInit {
  destFolderPathControl = new FormControl<string>({ value: '', disabled: true });
  @Output() dialogSubmit = new EventEmitter<string>();

  constructor(
    public dialogRef: MatDialogRef<SelectLocalFolderPathDialogComponent>,
    private spinner: SpinnerService,
    private snackbar: CommonSnackBarService,
    private offlineUtils: OfflineUtilsService
  ) {

  }

  ngOnInit() {
    this.setFormValue('');
  }

  setFormValue(folderPath: string) {
    this.destFolderPathControl = new FormControl<string>(
      { value: folderPath, disabled: false },
      [
        CustomValidators.requiredTrimmed(),
      ]
    );
  }

  transfer() {
    this.dialogSubmit.emit(this.destFolderPathControl.value);
  }

  getFolderPath() {
    this.spinner.show(true);
    setTimeout(() => {
      this.offlineUtils.getLocalFolderPath()
        .subscribe(folderPath => {
          if (folderPath) {
            this.destFolderPathControl.setValue(folderPath[0]);
          }
          this.spinner.hide(true);
        },
        error => {
          console.log(error);
          this.snackbar.open('Failed get local folder');
          this.spinner.hide(true);
        });
    }, 200);
  }
}
